import * as React from "react";

function SvgPromoterio(props, ref) {
  return (
    <svg
      viewBox="0 0 90 75"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fill="#899196" fillRule="evenodd">
        <path d="M74 19.5l2.8-1.8C70 7.9 60.5 1.4 50.8 0l-.7 3.3c8.8 1.1 17.6 7.1 23.9 16.2z" />
        <path d="M68.3 23.2l2.8-1.8C65.3 13 57.3 7.5 49.4 6.6l-.7 3.3c7 .7 14.2 5.6 19.6 13.3zM62.7 26.9l2.8-1.8c-4.9-7-11.4-11.4-17.6-11.8l-.7 3.3c5.1.1 11 4 15.5 10.3zM71.7 52.6l-3.3-.8c-.9 2.6-2.6 4.7-4.8 5.8-1.4.7-2.9 1.1-4.5 1.1-.4 0-.9 0-1.3-.1l2 3.4c1.9-.1 3.7-.6 5.4-1.4 3.1-1.6 5.3-4.4 6.5-8zM81.6 55c-1.9 6.5-5.9 11.6-11.7 14.6-1.5.8-3 1.4-4.6 1.8l1.8 3c1.5-.5 3-1.1 4.4-1.8C78.3 69 82.9 63.2 85 55.8l-3.4-.8z" />
        <path d="M78.3 54.2l-3.3-.8c-1.4 4.6-4.3 8.1-8.3 10.2-1.6.8-3.3 1.4-5.1 1.6l1.8 3.1c1.7-.4 3.3-1 4.8-1.8 5-2.5 8.4-6.8 10.1-12.3zM50.2 52.2C47.4 50 44.5 47 42.4 43c-1.9-3.7-3.2-7-3.5-10.5-4 6.6-8.7 11.3-14.1 15.3l-5.5 4s-2.5 2.4-.3 6.4c2 3.6 4.6 3.5 5.1 3.5.9 0 1.5-.7 1.9-.5 2.6.8 6.4 5.7 6.9 7.1.5 1.5 1.6.9 2.8.6 1.1-.4 2.7-1.2 1.8-2.5-.7-1-.8-.9-1.5-1.7-1.2-1.4-4.8-5.6-3.5-7.3.3-.4.7-.7 1.5-1.3 2.4-1.6 6.9-4.2 16.2-3.9z" />
        <path d="M61.9 33c-4.7-8.9-12.5-14.1-17.3-11.5-4.9 2.6-5 11.9-.3 20.8s12.5 14.1 17.3 11.5c4.8-2.6 5-11.9.3-20.8zm-1.6 17.5c-2.4 1.3-5.8.2-8.7-2.6-2.2-2-3-3.3-3.1-3.3.1 0 3.6 4.1 5.6 3.1 2.4-1.2 2.5-5.9.2-10.3s-6.2-7-8.6-5.7c-.8.4-1.4 1.3-1.7 2.4-.7-4.4.2-8 2.7-9.4 3.9-2 9.8 2.2 13.5 9.4 3.7 7.1 3.9 14.3.1 16.4zM178.2 46h2v2.1h-2V46z" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgPromoterio);
